import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateMessageRequest,
  DeleteMessageRequest,
  ViewMessageOverviewRequest,
  ViewMessagesRequest
} from './support.types';

export const requestViewMessageOverview =
  createAction<SagaPayload<ViewMessageOverviewRequest>['payload']>('request/ViewMessageOverview');

export const requestViewMessages = createAction<SagaPayload<ViewMessagesRequest>['payload']>('request/ViewMessages');

export const requestCreateMessage = createAction<SagaPayload<CreateMessageRequest>['payload']>('request/CreateMessage');

export const requestDeleteMessage = createAction<SagaPayload<DeleteMessageRequest>['payload']>('request/DeleteMessage');
